import React from 'react';
import Navbar from '../Components/Navbar/Navbar';
import B_A from '../Components/Background/B_A';
import About1 from '../Components/Section/About1';
import Footer from '../Components/Footer/Footer';
import About2 from '../Components/Section/About2';


const About = () => {
  return (
    <div>
      <B_A />
      
      <Navbar />
      <div style={{ height: '70vh' }}></div>
      <About1 />
      <About2 />
      <Footer />

    </div>);
}

export default About;
